var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { XForm } from "@bluelibs/x-ui-admin";
import { Service, Inject } from "@bluelibs/core";
import { SmileOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { UsersCollection, ExternalsCollection, } from "@bundles/UIAppBundle/collections";
import { UserRole } from "@root/api.types";
let ExternalEditForm = class ExternalEditForm extends XForm {
    constructor() {
        super(...arguments);
        this.user = undefined;
    }
    build() {
        var _a, _b;
        const { UIComponents } = this;
        const { t } = this.i18n;
        const roles = (_b = (_a = this.user) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : [];
        const isAdmin = roles.includes(UserRole.ADMIN) || roles.includes(UserRole.SHAREHOLDER);
        this.add([
            {
                id: "name",
                label: t("management.externals.fields.name"),
                name: ["name"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "email",
                label: t("management.externals.fields.email"),
                name: ["email"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "phone",
                label: t("management.externals.fields.phone"),
                name: ["phone"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "address",
                label: t("management.externals.fields.address"),
                name: ["address"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "city",
                label: t("management.externals.fields.city"),
                name: ["city"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "state",
                label: t("management.externals.fields.state"),
                name: ["state"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "zip",
                label: t("management.externals.fields.zip"),
                name: ["zip"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "country",
                label: t("management.externals.fields.country"),
                name: ["country"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "website",
                label: t("management.externals.fields.website"),
                name: ["website"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "targetBankAccount",
                label: t("management.externals.fields.targetBankAccount"),
                name: ["targetBankAccount"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "targetBankName",
                label: t("management.externals.fields.targetBankName"),
                name: ["targetBankName"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "type",
                label: t("management.externals.fields.type"),
                name: ["type"],
                required: true,
                tooltip: t("management.externals.fields.type_description"),
                component: Ant.Select,
                componentProps: {
                    options: [
                        {
                            label: t("management.externals.fields.external_type.client"),
                            value: "client",
                        },
                        {
                            label: t("management.externals.fields.external_type.provider"),
                            value: "provider",
                        },
                    ],
                },
            },
            ...(isAdmin
                ? [
                    {
                        id: "responsibleUserId",
                        label: t("management.externals.fields.responsibleUser"),
                        name: ["responsibleUserId"],
                        required: true,
                        render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", required: true }, void 0) }), void 0)),
                    },
                ]
                : []),
        ]);
    }
    setUser(user) {
        this.user = user;
    }
    static getRequestBody() {
        return {
            _id: 1,
            name: 1,
            email: 1,
            phone: 1,
            address: 1,
            city: 1,
            state: 1,
            zip: 1,
            country: 1,
            website: 1,
            targetBankAccount: 1,
            targetBankName: 1,
            type: 1,
            responsibleUser: {
                _id: 1,
                fullName: 1,
            },
            responsibleUserId: 1,
        };
    }
    onSubmit(_id, values) {
        const { t } = this.i18n;
        return this.collection
            .updateOne(_id, { $set: values })
            .then(({ _id }) => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.externals.edit_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
        })
            .catch((err) => {
            Ant.notification.warn({
                message: t("generics.error"),
                description: t("generics.error_message"),
            });
        });
    }
};
__decorate([
    Inject(() => ExternalsCollection),
    __metadata("design:type", typeof (_a = typeof ExternalsCollection !== "undefined" && ExternalsCollection) === "function" ? _a : Object)
], ExternalEditForm.prototype, "collection", void 0);
ExternalEditForm = __decorate([
    Service({ transient: true })
], ExternalEditForm);
export { ExternalEditForm };
